import { Button } from "@/elements"
import { ButtonProps } from "@/elements/Button/Button"
import { forwardRef } from "react"

export type DialogFooterProps = {
  primaryButton?: ButtonProps
  secondaryButton?: ButtonProps
  tertiaryButton?: ButtonProps
}

export const DialogFooter = forwardRef<HTMLDivElement, DialogFooterProps>(
  ({ primaryButton, secondaryButton, tertiaryButton }, ref) => (
    <>
      <div className="bottom-[72px] left-0 flex h-[1px] w-full bg-bg-3" />
      <div ref={ref} className="relative bottom-0 z-10 flex h-fit flex-row justify-between bg-bg-1 py-4 pl-5 pr-8">
        <div className="flex">{tertiaryButton && <Button variant="transparent" {...tertiaryButton} />}</div>
        <div className="flex flex-row justify-end gap-x-2">
          {secondaryButton && <Button variant="transparent" {...secondaryButton} />}
          {primaryButton && <Button variant="primary" {...primaryButton} />}
        </div>
      </div>
    </>
  )
)
DialogFooter.displayName = "DialogFooter"
